import { useMemo } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Dropdown, DropdownButton } from "@similarweb/ui-components";

import { StyledBaseDropdownButtonWrap } from "app/pages/sales-intelligence/sub-modules/advanced-search/components/common-styles";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";

import { columnsSelectionTrackingService } from "../../columnsSelectionTrackingService";
import type { ColumnCategoryConfig } from "../../types";

import { DropdownContainer, StyledSimpleDropdownItem } from "./styles";

export type ColumnsCategorySelectProps = {
    value: string;
    categoryConfig: readonly ColumnCategoryConfig[];
    onChange(value: string): void;
};

export const ColumnsCategorySelect = ({ value, categoryConfig, onChange }: ColumnsCategorySelectProps) => {
    const translate = useTranslation();

    const handleSelect = (element: { id: string }) => {
        columnsSelectionTrackingService.trackChangeCategory(element.id);
        onChange(element.id);
    };

    const selectedLabelKey = useMemo(() => {
        return categoryConfig.find((c) => c.name === value)?.labelKey ?? categoryConfig[0].labelKey;
    }, [categoryConfig, value]);

    return (
        <DropdownContainer id="columns-category-select">
            <Dropdown
                onClick={handleSelect}
                appendTo="#columns-category-select"
                width="250px"
                dropdownPopupPlacement="ontop-left"
            >
                {[
                    <StyledBaseDropdownButtonWrap
                        key="dropdown-button"
                        buttonTextColor={colorsPalettes.carbon[400]}
                    >
                        <DropdownButton>{translate(selectedLabelKey)}</DropdownButton>
                    </StyledBaseDropdownButtonWrap>,
                ].concat(
                    categoryConfig.map((c) => (
                        <StyledSimpleDropdownItem
                            key={c.name}
                            id={c.name}
                            selected={c.name === value}
                        >
                            {translate(c.labelKey)}
                        </StyledSimpleDropdownItem>
                    )),
                )}
            </Dropdown>
        </DropdownContainer>
    );
};
